import { render } from "./TagEditModal.vue?vue&type=template&id=ecfc0a36&scoped=true&ts=true"
import script from "./TagEditModal.vue?vue&type=script&lang=ts"
export * from "./TagEditModal.vue?vue&type=script&lang=ts"

import "./TagEditModal.vue?vue&type=style&index=0&id=ecfc0a36&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecfc0a36"]])

export default __exports__